<ng-container *ngIf="journeyList">
    <div *ngFor="let journey of journeyList; let i = index" class="sector-segment-wrapper">
        <segment [segmentItem]="booking.segment[i][journey]"
                 type="sectorListTitle"
                 [carrier]="booking.carrier"></segment>

        <ng-container *ngFor=" let sectorItem of booking.segment[i][journey].sector">
            <sector [sectorItem]="sectorItem"
                    [carrier]="booking.carrier"></sector>
        </ng-container>
    </div>
</ng-container>
